import { Button, Popconfirm, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";
import { CardAttachButton, CardList } from "entities/card";
import { getProfile, ViewerHead } from "entities/viewer";
import { logout } from "features/auth";
import { LanguageSelectBlock } from "features/language-switcher";
import { PushNotificationsBlock } from "features/push-notifications";

export const ProfilePage = () => {
  const { t } = useTranslation();

  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: () => getProfile(),
  });

  const exit = () => {
    logout()
      .catch((error) => error)
      .finally(() => {
        localStorage.removeItem("token");
        window.location.reload();
      });
  };

  return (
    <>
      <Typography.Title level={1}>{t("profile.title")}</Typography.Title>
      <Typography.Text
        style={{
          fontSize: 16,
          marginBottom: 24,
          display: "block",
          color: "var(--color-grey)",
        }}
      >
        {t("profile.personal_info")}
      </Typography.Text>
      <Space orientation="vertical" size="middle" style={{ display: "flex" }}>
        <ViewerHead />
        <LanguageSelectBlock />
        <PushNotificationsBlock />
        <Typography.Title level={4}>
          {t("profile.payment_cards")}
        </Typography.Title>
        <CardList />
        {!!profile?.features?.wooppay_card_payouts && (
          <CardAttachButton block />
        )}

        <Popconfirm
          title={"Вы точно хотите выйти из приложения?"}
          onConfirm={exit}
          okText={"Выйти"}
          cancelText={"Отмена"}
          icon={false}
        >
          <Button block>{t("profile.exit")}</Button>
        </Popconfirm>
      </Space>
    </>
  );
};
